module.exports = __webpack_public_path__ + "img/plausible.5dd7cb9c.jpg";